module.exports = __webpack_public_path__ + "img/truck_fmn.892a01ae.png";